/**
 * Created by sswaminathan on 6/10/22
 * File: ModifySubscription
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Textarea } from '@panwds/react-form-legacy'
import { Banner, Field, LoadingPage, Body } from '@panwds/react-ui'
import { groupBy } from 'lodash'
import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { NOTE_SECTION } from '../constants/SubscriptionConstant'
/**
 *   TODO: Brief what is this component/class do
 */


const ModifySubscription = (props) => {
  const { isFormLoading, appInformation, setDisabled, showErrorMsg } = props
  const { getValues } = useFormContext()

  const changeControl = useCallback((value) => {
    const groupByDisplayName = groupBy(appInformation, 'app_id')
    const keys = Object.keys(groupByDisplayName)
    const values = getValues()
    let isValuePresent = false
    keys.forEach((each) => {
      if (values[each] && values[each].length > 0 && values[each] !== NOTE_SECTION) {
        isValuePresent = true
      }
    })
    setDisabled(!isValuePresent)
  }, [appInformation, getValues, setDisabled])
  return <>
    {showErrorMsg.showError && <div>
      <Banner appearance="error" showIcon>
        <Body addClassName="tw-pt-1" size="sm">
          {showErrorMsg.errorMsg}
        </Body>
      </Banner>
    </div>}
    {isFormLoading ? <LoadingPage/> : <div className={'tw-flex tw-flex-col tw-p-0 tw-m-2'}>
      {Object.keys(appInformation, 'app_id').map((each, idx) => {
        return <Field
          key={idx}
          label={appInformation[each].license_display_name}
          control={<Textarea
            appearance="default"
            name={appInformation[each].app_id}
            placeholder={NOTE_SECTION}
            rowsMax={8}
            rowsMin={4}
            register={{
              required: false,
              value: NOTE_SECTION,
              onChange: async (e) => {
                changeControl(e)
              },
            }}
          />}
        />
      })}
    </div>
    }
  </>
}

ModifySubscription.propTypes = {}
export default ModifySubscription
